export default __webpack_public_path__ + "static/media/hm2_000_ortf_48k.52d5438d.mp3";